import React, { useState, useEffect, Fragment } from "react";

const usePotentialTable = (
    potentialArr,
    handleDelPotential,
    handleEditPotential,
    onClickToggleFromTable
) => {
  const [thead] = useState(["Potential","Action"]);
  const [trow, setTrow] = useState([]);

  useEffect(() => {
    let trowArr = potentialArr.map((el) => {
      return {
        "Potential": el.potential,
     
        Action: (
          <Fragment>
            <i
              className="fas fa-edit ml-4"              
              onClick={() => {
                handleEditPotential(el, el.potentialId);
                onClickToggleFromTable();
             }}
            ></i>
            <i
              className="fas fa-trash"
              onClick={() => handleDelPotential(el.potentialId)}
            ></i>
            
          </Fragment>
        ),
      };
    });

     setTrow(trowArr);
  }, [
    potentialArr,
    handleDelPotential,
    handleEditPotential,
    onClickToggleFromTable
  ]);

  return { thead, trow };
};

export default usePotentialTable;